import {Component, OnInit} from '@angular/core';
import {CommonService} from "../common.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-focusarea',
    templateUrl: './focusarea.component.html',
    styleUrls: ['./focusarea.component.css']
})
export class FocusareaComponent implements OnInit {
    weaknessText: any;
    strengthText: any;
    weakness: any;
    strength: any;

    masterApi: any;
    totalCampus: number = 0;
    campusInfo: any;
    finalCampusArr: any;
    AllCampusArr = [];
    keyArea = [];

    constructor(public commonService: CommonService, private router: Router) {
        this.weakness = this.strength = this.weaknessText = this.strengthText = "";
        this.campusInfo = this.commonService.getAuditInfo();
        console.log(this.commonService.getAuditInfo());
        this.campusInfo.forEach((value: any) => {
            this.totalCampus = this.totalCampus + value['facilitators'].length;
        });
        this.masterApi = this.commonService.getMasterApi();
        let campusArr = [];
        let fdim001 = {1: 0, 2: 0, 3: 0, 'text': 'Integrity to class process'};
        let fdim002 = {1: 0, 2: 0, 3: 0, 'text': 'Usage of course tools and enablers'};
        let fdim003 = {1: 0, 2: 0, 3: 0, 'text': 'Way of conducting the class'};
        let fdim004 = {1: 0, 2: 0, 3: 0, 'text': 'Energy level of participants'};
        let fdim005 = {1: 0, 2: 0, 3: 0, 'text': 'Quality of group dynamics'};
        let fdim006 = {1: 0, 2: 0, 3: 0, 'text': 'Quality of engagement with ideas'};

        this.campusInfo.forEach(function (result: any, campusIndex: number) {
            // cons
            let countBelow: number = 0;
            let subCampArr = [];

            let dim001 = {1: 0, 2: 0, 3: 0, 'text': 'Integrity to class process'};
            let dim002 = {1: 0, 2: 0, 3: 0, 'text': 'Usage of course tools and enablers'};
            let dim003 = {1: 0, 2: 0, 3: 0, 'text': 'Way of conducting the class'};
            let dim004 = {1: 0, 2: 0, 3: 0, 'text': 'Energy level of participants'};
            let dim005 = {1: 0, 2: 0, 3: 0, 'text': 'Quality of group dynamics'};
            let dim006 = {1: 0, 2: 0, 3: 0, 'text': 'Quality of engagement with ideas'};
            let arrMedium: number = 0;
            let arrHigh: number = 0;
            subCampArr['count'] = result.facilitators.length;
            let name = [];
            let focusArray = [];
            let indexNumber: number;
            console.log(result.facilitators);
            result.facilitators.forEach(function (facilitators: any, index: number) {
                if (facilitators.audits) {
                    var auditData = Object.values(facilitators.audits[0].auditData);
                    for (let i = 0; i < 6; i++) {
                        eval('dim00' + (i + 1))[auditData[i]]++;
                        eval('fdim00' + (i + 1))[auditData[i]]++;

                    }
                    campusArr[campusIndex] = [dim001, dim002, dim003, dim004, dim005, dim006];
                }
            }.bind(this));
        }.bind(this));

        this.finalCampusArr = campusArr;
        console.log(this.finalCampusArr[1]);
        console.log(campusArr.length);
        for (let i = 0; i < campusArr.length; i++) {
            if (!(typeof campusArr[i] === 'undefined')) {
                let val = campusArr[i];
                console.log(val);
                //console.log(val);
                let maxVal = val[0][1] + val[0][2] + val[0][3];
                //console.log(maxVal);
                let maxArrFirst = val.map(x => x[1]);
                let maxArrThird = val.map(x => x[3]);
                // console.log(maxArrFirst[this.indexOfMax(maxArrFirst) - 1]);
                //console.log(maxArrFirst[this.indexOfMax(maxArrFirst) - 1]/maxVal);
                this.keyArea.push([this.indexOfMax(maxArrFirst), this.indexOfMax(maxArrThird), maxArrFirst[this.indexOfMax(maxArrFirst) - 1] / maxVal, maxArrThird[this.indexOfMax(maxArrThird) - 1] / maxVal]);
            }else{
                this.keyArea.push([0, 0, 0,0]);
            }
        }
        campusArr.forEach(function (val: any, index: number) {

        }.bind(this));

        this.AllCampusArr = [fdim001, fdim002, fdim003, fdim004, fdim005, fdim006];
        let maxVal = this.AllCampusArr[0][1] + this.AllCampusArr[0][2] + this.AllCampusArr[0][3];
        var maxArrFirst = this.AllCampusArr.map(x => x[1]);
        var maxArrThird = this.AllCampusArr.map(x => x[3]);
        this.keyArea.unshift([this.indexOfMax(maxArrFirst), this.indexOfMax(maxArrThird), maxArrFirst[this.indexOfMax(maxArrFirst) - 1] / maxVal, maxArrThird[this.indexOfMax(maxArrThird) - 1] / maxVal]);

        if (maxArrFirst[this.indexOfMax(maxArrFirst) - 1] / maxVal >= 0.5) {
            this.weaknessText = this.masterApi['datadim00' + this.indexOfMax(maxArrFirst)].text;
            this.weakness = this.masterApi['datadim00' + this.indexOfMax(maxArrFirst)].interpretation.weakness;
        }
        if (maxArrThird[this.indexOfMax(maxArrThird) - 1] / maxVal >= 0.5) {
            this.strengthText = this.masterApi['datadim00' + this.indexOfMax(maxArrThird)].text;
            this.strength = this.masterApi['datadim00' + this.indexOfMax(maxArrThird)].interpretation.strength;
        }
    }

    getKeys(index) {
        console.log(this.keyArea);
        //console.log(this.keyArea);
        this.weakness = this.strength = this.weaknessText = this.strengthText = "";
        //console.log(this.masterApi);
        this.keyArea[index][0];
        this.keyArea[index][1];
        //console.log(this.keyArea[index][2]);
        //console.log(this.keyArea[index][3]);
        if (this.keyArea[index][2] >= 0.5) {
            this.weaknessText = this.masterApi['datadim00' + this.keyArea[index][0]].text;
            this.weakness = this.masterApi['datadim00' + this.keyArea[index][0]].interpretation.weakness;
        }
        if (this.keyArea[index][3] >= 0.5) {
            this.strengthText = this.masterApi['datadim00' + this.keyArea[index][1]].text;
            this.strength = this.masterApi['datadim00' + this.keyArea[index][1]].interpretation.strength;
        }
        console.log(this.strength);
    }

    indexOfMax(a) {
        var highest = 0;
        for (var i = 1; i < a.length; i++) {
            if (a[i] > a[highest]) highest = i;
        }
        return highest + 1;
    }

    ngOnInit() {
        /// console.log("hii");
    }

}



// WEBPACK FOOTER //
// /var/www/illumine/desktop/src/app/focusarea/focusarea.component.ts